import React from "react"
import types from "prop-types"
import { SEGMENTS } from "utils/departmentSegmentHelpers"
import { useTaskFormContext } from "contexts/TaskFormContext"
import { departmentIdentifier } from "utils/taskHelpers"
import TaskDepartmentSegmentCheckbox from "../UI/TaskDepartmentSegmentCheckbox"

const TaskMemberDepartmentSegments = ({ department }) => {
  const {
    deselectMemberDepartmentSegment,
    selectMemberDepartmentSegment,
    selectedAssigneeDepartmentSegments,
  } = useTaskFormContext()

  const segmentSelected = (segment) => department.segments?.includes(segment)

  const segmentUnavailable = (segment) => (
    (selectedAssigneeDepartmentSegments[department.departmentId] ?? []).includes(segment)
  )

  const toggleSelection = (segment) => () => {
    const toggleFunction = segmentSelected(segment)
      ? deselectMemberDepartmentSegment
      : selectMemberDepartmentSegment

    toggleFunction(departmentIdentifier(department), segment)
  }

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-3 md:grid-cols-3 gap-1 md:gap-4 items-center justify-between">
      {
        SEGMENTS.map((segment) => (
          <TaskDepartmentSegmentCheckbox
            className="text-sm"
            key={segment}
            segment={segment}
            toggleSelection={toggleSelection}
            disabled={segmentUnavailable(segment)}
            selected={segmentSelected(segment)}
            groupIdentifier="member"
          />
        ))
      }
    </div>
  )
}

TaskMemberDepartmentSegments.propTypes = {
  department: types.object.isRequired,
}

export default TaskMemberDepartmentSegments
